import { appLogo } from '@/constants/setupBasics';
import { urlToWhatsapp } from '@/constants/constants';
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";
import isColApp from '@gcloud-npm/utils.common.is-colapp';
import { APP, WEB } from '@/containers/my-data/mis-consentimientos/tools';

export const htmlEncode = (s) => {
  const el = document.createElement('div');
  let str = s;
  str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
  str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
  el.innerHTML = str;
  const returnString = el.textContent;
  return returnString;
};

export const concatUrl = (url, param) => {
  if (url) {
    const checkParams = url.indexOf('?') > -1;
    const concat = checkParams ? '&' : '?';
    const urlFinal = `${url}${concat}${param}`;
    return urlFinal;
  }
  return '';
};
export const externalLink = (link) => {
  if (link !== appLogo.link) {
    return (
      link.indexOf('http:') > -1 ||
      link.indexOf('https:') > -1 ||
      link.indexOf('mailto:') > -1
    );
  }
  return true;
};

export const convertToKebabCase = (string) => {
  if (string) {
    return string
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .toLowerCase();
  }

  return null;
};

export const numberPrice2ClientStringPrice = (
  number,
  decimals = 2,
  decimalChar = ',',
  thousandChar = '.'
) => {
  let res = number;
  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);
  const splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  res = splitNum.join(decimalChar);
  return res;
};

export const text2html = (text) => {
  let htmlConverted = text.replace(/<b>/g, '<span class="bold">');
  htmlConverted = htmlConverted.replace(/<\/b>/g, '</span>');
  return { __html: htmlConverted };
};

export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase();
};
export const whichAnimationEvent = () => {
  const el = document.createElement('fakeelement');
  const transitions = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
  };

  let transition = null;

  Object.keys(transitions).forEach((t) => {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
};
export const normalizeAccent = (str) => {
  let strReturn = null;
  if (str) {
    strReturn = str;
    strReturn = strReturn.replace(/á/g, 'a');
    strReturn = strReturn.replace(/é/g, 'e');
    strReturn = strReturn.replace(/í/g, 'i');
    strReturn = strReturn.replace(/ó/g, 'o');
    strReturn = strReturn.replace(/ú/g, 'u');
  }
  return strReturn;
};

export const normalizeString = (str) => {
  let strReturn = null;
  if (str) {
    strReturn = str.toLowerCase();
    strReturn = normalizeAccent(strReturn);
    strReturn = strReturn.replace(/[^a-z]/g, '');
  }
  return strReturn;
};

export const replacehttp2https = (input) => {
  if (input) {
    return input.replace('http://', 'https://');
  }
  return null;
};
export const openWhatsappInNewWindows = () => {
  window.open(urlToWhatsapp, '_blank');
};

export const addSpacesNumberPhone = (input) => {
    return input.match(/.{1,3}/g).join(' ');
}

export const navigateBasedOnEnvironment = (navigate, urlToNavigate, needWindowLocation) => {
  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
  let urlToNavigateEnvironment = urlToNavigate;
  if (currentEnv === ENV_NAME.QA || currentEnv === ENV_NAME.QA_SSR) {
    urlToNavigateEnvironment = `/qa${urlToNavigateEnvironment}`;
  } else if (currentEnv === ENV_NAME.DEV || currentEnv === ENV_NAME.DEV_SSR) {
    urlToNavigateEnvironment = `/develop${urlToNavigateEnvironment}`;

  }
  const isColAppBool = isColApp();
  const webAppValue = isColAppBool ? APP : WEB;

  if (webAppValue === APP && typeof window !== 'undefined' && needWindowLocation) {
    window.location.href = urlToNavigateEnvironment;
  } else {
    navigate(urlToNavigateEnvironment);
  }
}

export const getFullUrl = (href, query = {}, removeFilters) => {

  const { offerCategory, segment, customTags } = query;
  const queryParamsToKeep = {};
  const [hrefPathname, hrefSearch = ''] = href.split('?');
  const hrefQueryParams = new URLSearchParams(hrefSearch);

  if (offerCategory) {
    queryParamsToKeep.offerCategory = offerCategory;
  }

  if (segment) {
    queryParamsToKeep.segment = segment;
  }

  //Contingencia para poder borrar el filtro de renovacion
  if (removeFilters) {
    delete query.customTags;
  }

  if (customTags && !removeFilters) {
    queryParamsToKeep.customTags = customTags;
  }

  Object.keys(queryParamsToKeep).forEach(key => {
    hrefQueryParams.set(key, query[key]); // Reemplaza o añade el valor
  });

  const fullUrl = `${hrefPathname}${hrefQueryParams.toString() ? `?${hrefQueryParams.toString()}` : ''}`;
  return fullUrl;
}

export const getFullAEMStaticSrc = (pathname, currentEnv) => {
  let basePath = "";
  if (isAEMStatic(pathname)) {
    // Caso productivo
    if (!currentEnv || currentEnv === "prod" || currentEnv === "local") {
      basePath = "https://prod.adb.col.movistar.es";
      // Resto de entornos no productivos
    } else {
      basePath = "https://author.prod.aem.col.movistar.es";
    }
  }
  return `${basePath}${pathname}`;
};

export const getPathFromUrl = (url) => {
  try {
    const urlObject = new URL(url);
    return urlObject.pathname;
  } catch (e) {
    console.error('Invalid URL:', url);
    return null;
  }
};

